import { Link } from "react-router-dom";
import { Plane, ArrowRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

/* Warm CTA card at the bottom of the home page — mirrors the
   "Ready for Your Next Adventure?" panel from the Design 2 mockup.
   Hides itself for signed-in users so it never pesters existing members. */

export default function HomeAdventureCTA() {
  const { user } = useAuth();
  if (user) return null;
  return (
    <section data-testid="home-adventure-cta">
      <div className="rounded-2xl border border-border bg-gradient-to-br from-sky-50 via-white to-emerald-50 p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-5 shadow-warm-sm">
        <div className="shrink-0 w-14 h-14 rounded-2xl bg-primary text-primary-foreground inline-flex items-center justify-center shadow-warm-sm">
          <Plane className="w-6 h-6 -rotate-45" strokeWidth={1.75} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-serif font-800 text-2xl text-primary leading-tight">Ready for your next adventure?</h3>
          <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">
            Join My Social Pulse and be part of a global community of travellers — plan trips, share stories, and keep everything organized.
          </p>
        </div>
        <div className="shrink-0 flex flex-wrap gap-2 w-full sm:w-auto">
          <Link to="/register" data-testid="home-adventure-cta-signup"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-primary text-primary-foreground font-700 min-h-[44px] hover:opacity-95 tap">
            Create free account <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/login" data-testid="home-adventure-cta-signin"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full border border-primary text-primary font-700 min-h-[44px] hover:bg-primary hover:text-primary-foreground transition-colors tap">
            Sign in
          </Link>
        </div>
      </div>
    </section>
  );
}
